import { isError500 } from './errors'

const QUERY_RETRIES_MAX = 3

/**
 * Keep previous query data between requests - data does not set to null when query key is changed.
 * Provides safe types.
 *
 * @param {object} previousData
 * @return {object}
 */
export function keepPreviousDataPlaceholder<
  TQueryFnData = unknown,
  TQueryData = TQueryFnData,
>(previousData: TQueryData | undefined): TQueryData | undefined {
  return previousData
}

/**
 * Retries only when the status is 500 and skips the rest.
 *
 * @param maxRetries Maximum retries in case of status 500.
 */
export function retryOnFailures(maxRetries = QUERY_RETRIES_MAX) {
  return (failureCount: number, error: Error) =>
    isError500(error) && failureCount < maxRetries
}
